__webpack_require__.p = "/interactive/microsoft/intel/hybridcloud/bridgetoinnovation/";